import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "@env";
import type { OrderDetails } from "@models";
import { Observable } from "rxjs";

@Injectable({ providedIn: "root" })
export class OrderService {
  private _purchasesApiUrl: string = environment.purchasesApiUrl;

  constructor(private _httpClient: HttpClient) {}

  public getOrderDetails(orderId: string): Observable<OrderDetails> {
    return this._httpClient.get<OrderDetails>(`${this._purchasesApiUrl}/orders/${orderId}/details`);
  }
}
